import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"search\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.66 12.1C13.49 11.14 14 9.88 14 8.5C14 5.46 11.54 3 8.5 3C5.46 3 3 5.46 3 8.5C3 11.54 5.46 14 8.5 14C9.87 14 11.13 13.5 12.1 12.66L16.22 16.78L16.79 16.21L12.67 12.09L12.66 12.1ZM8.5 13.2C5.9 13.2 3.8 11.1 3.8 8.5C3.8 5.9 5.9 3.8 8.5 3.8C11.1 3.8 13.2 5.9 13.2 8.5C13.2 11.1 11.1 13.2 8.5 13.2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol